import { useApi } from '@hooks/useApi';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { useCheckUserPermissions } from '@hooks/checkUserPermisions';
import { AcquirerLink } from '@root/globalTypes';

export function useGetAcquirerLink({ acquirerId, id }: { acquirerId: string; id: string }) {
  const { isLogged, isMerchant } = useCheckUserPermissions();
  const { query } = useApi();

  const { data, isPending } = useQuery<AcquirerLink>({
    queryKey: [...queryKeys.acquirerLinks, id],
    queryFn: (): Promise<AcquirerLink> =>
      query({
        path: `v1/staff/acquirers/${acquirerId}/links/${id}`,
      }),
    placeholderData: (previousValue) => previousValue,
    enabled: isLogged && !isMerchant,
  });

  return {
    data: data,
    isPending,
  };
}
